import { purchaseOrdersQuery } from "@common/api/purchase-orders"
import { Button } from "@common/components/ui/button"
import { PURCHASE_ORDERS } from "@common/flags"
import { useMaxWidth } from "@common/hooks/use-mobile"
import {
  createFileRoute,
  Link,
  Outlet,
  useRouterState,
} from "@tanstack/react-router"
import { DETAIL_SHEET_BREAKPOINT } from "@/components/layout/detail-panel"
import { ListPage } from "@/components/layout/list-page"
import { ListToolbar } from "@/components/layout/list-toolbar"
import { requireFeatureFlag } from "@/lib/require-feature-flag"
import { requirePermission } from "@/lib/require-permission"
import { PurchaseOrderTable } from "./-components/purchase-order-table"
import { PURCHASE_ORDER_LIST } from "./-lib/order"

const INDEX_ROUTE = "/_layout/inventory_/purchase-orders/"

export const Route = createFileRoute("/_layout/inventory_/purchase-orders")({
  staticData: {
    breadcrumb: [
      { label: "Inventory", href: "/inventory" },
      { label: "Purchase orders", href: "/inventory/purchase-orders" },
    ],
  },
  beforeLoad: async ({ context: { queryClient } }) => {
    await requirePermission(queryClient, "purchase_order:read", "/")
    await requireFeatureFlag(queryClient, PURCHASE_ORDERS)
  },
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(purchaseOrdersQuery(PURCHASE_ORDER_LIST)),
  component: PurchaseOrdersPage,
})

function PurchaseOrdersPage(): React.ReactElement {
  const open = useRouterState({
    select: (state) => state.matches.at(-1)?.routeId !== INDEX_ROUTE,
  })
  const compact = useMaxWidth(DETAIL_SHEET_BREAKPOINT)

  return (
    <ListPage
      toolbar={
        <ListToolbar
          actions={
            <Button asChild size="sm" variant="outline">
              <Link to="/inventory">Order parts</Link>
            </Button>
          }
        />
      }
      pane={open && !compact ? "split" : "closed"}
      detail={<Outlet />}
    >
      <PurchaseOrderTable />
    </ListPage>
  )
}
